import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../../Layout"
import { AtaReuniaoForm } from "../../modais"

class AtaReuniaoCreateForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/atareuniao")
  }
  render() {
    return (
      <Layout tabActive="Fiscalização">
        <AtaReuniaoForm callBackAtaReuniao={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(AtaReuniaoCreateForm)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/ata-reuniao/AtaReuniaoCreateForm.js